module.exports = __webpack_public_path__ + "img/member-btn.36facf19.png";